// istanbul ignore file

import ProgressLogo from './ProgressLogo';
import ProgressCircular from './ProgressCircular';

const Progress = {};

Progress.Logo = ProgressLogo;
Progress.Circular = ProgressCircular;

export default Progress;
